module.exports = __webpack_public_path__ + "static/media/ishaan.94761527.jpg";